import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MergeAccountComponent} from './merge-account.component';

const routes: Routes = [
  {
    path: 'mergeaccount',
    component: MergeAccountComponent,
    data: {
      title: 'Merge Account'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class MergeAccountRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/merge-account/merge-account-routing.module.ts